var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-4fa8778c"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { style: { "position": "relative", "height": "100%" } };
var _hoisted_2 = { key: 0 };
var _hoisted_3 = { key: 1 };
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import { teamsToCoordinates, transportsToCoordinates } from '../../../helpers/Converters';
import { key } from '../../../store';
import AssignmentMapTeamMarker from './marker/AssignmentMapTeamMarker.vue';
import AssignmentMapTransportMarker from './marker/AssignmentMapTransportMarker.vue';
import GenericMapView from '../../generic/map/GenericMapView.vue';
import UnpositionedTeamsList from './UnpositionedTeamsList.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AssignmentMapView',
    props: {
        positionedTeams: {
            type: Array,
            default: function () { return []; },
        },
        unpositionedTeams: {
            type: Array,
            default: function () { return []; },
        },
        transportOrigins: {
            type: Array,
            default: function () { return []; },
        },
        showMapMarkerBounds: {
            type: Boolean,
            default: false,
        },
    },
    setup: function (__props) {
        var props = __props;
        var t = useI18n({ useScope: 'global' }).t;
        var store = useStore(key);
        var focusedTransport = computed(function () {
            var _a;
            var focusedTransportId = store.state.assignmentPage.focusedTransportId;
            if (!focusedTransportId) {
                return null;
            }
            return (_a = store.state.transports.data.find(function (transport) { return transport.transportRequestId === focusedTransportId; })) !== null && _a !== void 0 ? _a : null;
        });
        var focusedTeam = computed(function () {
            var _a, _b;
            var focusedTeamId = ((_a = focusedTransport.value) === null || _a === void 0 ? void 0 : _a.teamId) || null;
            if (!focusedTeamId) {
                return null;
            }
            return (_b = store.state.teams.data.find(function (team) { return team.id === focusedTeamId; })) !== null && _b !== void 0 ? _b : null;
        });
        var focusedTransportCoordinates = function () {
            var coordinates = [];
            if (focusedTransport.value) {
                coordinates.push(focusedTransport.value.coordinates);
                coordinates.push(focusedTransport.value.destinationCoordinates);
            }
            if (focusedTeam.value) {
                coordinates.push(focusedTeam.value.position);
            }
            return coordinates;
        };
        var mapMarkerCoordinates = computed(function () {
            if (store.state.assignmentPage.focusedTransportId) {
                return focusedTransportCoordinates();
            }
            else {
                return __spreadArray(__spreadArray([], teamsToCoordinates(props.positionedTeams), true), transportsToCoordinates(props.transportOrigins), true);
            }
        });
        var toggleInfoWindow = function (infoWindowId) {
            store.state.assignmentPage.activeInfoWindowId === infoWindowId ?
                closeInfowWindow() :
                openInfoWindow(infoWindowId);
        };
        var openInfoWindow = function (infoWindowId) {
            store.commit('assignmentPage/setActiveInfoWindowId', infoWindowId);
        };
        var closeInfowWindow = function () {
            store.commit('assignmentPage/setActiveInfoWindowId', null);
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_unref(store).state.assignmentPage.focusedTransportId)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = function ($event) { return (_unref(store).dispatch('assignmentPage/unfocusTransport')); }),
                        class: "unfocus-button"
                    }, _toDisplayString(_unref(t)('assignment.map.removeSelection')), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                _createVNode(GenericMapView, {
                    "map-marker-coordinates": mapMarkerCoordinates.value,
                    "show-map-marker-bounds": __props.showMapMarkerBounds
                }, {
                    "map-markers": _withCtx(function () { return [
                        (focusedTransport.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(AssignmentMapTransportMarker, {
                                    transport: focusedTransport.value,
                                    isOrigin: true,
                                    "active-info-window-id": _unref(store).state.assignmentPage.activeInfoWindowId,
                                    "toggle-info-window": toggleInfoWindow
                                }, null, 8 /* PROPS */, ["transport", "active-info-window-id"]),
                                _createVNode(AssignmentMapTransportMarker, {
                                    transport: focusedTransport.value,
                                    isOrigin: false,
                                    "active-info-window-id": _unref(store).state.assignmentPage.activeInfoWindowId,
                                    "toggle-info-window": toggleInfoWindow
                                }, null, 8 /* PROPS */, ["transport", "active-info-window-id"]),
                                (focusedTeam.value)
                                    ? (_openBlock(), _createBlock(AssignmentMapTeamMarker, {
                                        key: 0,
                                        team: focusedTeam.value,
                                        "active-info-window-id": _unref(store).state.assignmentPage.activeInfoWindowId,
                                        "toggle-info-window": toggleInfoWindow
                                    }, null, 8 /* PROPS */, ["team", "active-info-window-id"]))
                                    : _createCommentVNode("v-if", true)
                            ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.positionedTeams, function (team) {
                                    return (_openBlock(), _createBlock(AssignmentMapTeamMarker, {
                                        key: team.id,
                                        team: team,
                                        "active-info-window-id": _unref(store).state.assignmentPage.activeInfoWindowId,
                                        "toggle-info-window": toggleInfoWindow
                                    }, null, 8 /* PROPS */, ["team", "active-info-window-id"]));
                                }), 128 /* KEYED_FRAGMENT */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.transportOrigins, function (transport) {
                                    return (_openBlock(), _createBlock(AssignmentMapTransportMarker, {
                                        key: transport.transportRequestId,
                                        transport: transport,
                                        isOrigin: true,
                                        "active-info-window-id": _unref(store).state.assignmentPage.activeInfoWindowId,
                                        "toggle-info-window": toggleInfoWindow
                                    }, null, 8 /* PROPS */, ["transport", "active-info-window-id"]));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                    ]; }),
                    "map-footer-content": _withCtx(function () { return [
                        (__props.unpositionedTeams.length)
                            ? (_openBlock(), _createBlock(UnpositionedTeamsList, {
                                key: 0,
                                "unpositioned-teams": props.unpositionedTeams
                            }, null, 8 /* PROPS */, ["unpositioned-teams"]))
                            : _createCommentVNode("v-if", true)
                    ]; }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["map-marker-coordinates", "show-map-marker-bounds"])
            ]));
        };
    }
});
